import { useState, useEffect } from 'react';
import { apiClient } from '../../lib/api-client.js';

interface Checkin {
  id: string;
  checkinAt: string;
  user: { id: string; nickname: string; avatarUrl?: string };
}

interface RecentCheckinsProps {
  spotId: string;
}

function formatCheckinTime(checkinAt: string): string {
  const date = new Date(checkinAt);
  const isToday = date.toDateString() === new Date().toDateString();
  if (isToday) {
    return date.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' });
  }
  return date.toLocaleDateString('ja-JP', { month: 'numeric', day: 'numeric' });
}

export function RecentCheckins({ spotId }: RecentCheckinsProps) {
  const [checkins, setCheckins] = useState<Checkin[]>([]);

  useEffect(() => {
    apiClient.get<Checkin[]>(`/spots/${spotId}/checkins`).then((data) => {
      if (!data) return;
      const oneMonthAgo = new Date();
      oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
      setCheckins(data.filter((c) => new Date(c.checkinAt) >= oneMonthAgo));
    });
  }, [spotId]);

  if (checkins.length === 0) {
    return (
      <p className="text-sm text-gray-500 text-center py-6">直近1ヶ月のチェックインはありません</p>
    );
  }

  return (
    <ul className="space-y-2">
      {checkins.map((checkin) => (
        <li key={checkin.id} className="flex items-center gap-2 text-sm">
          <div className="w-7 h-7 bg-gray-200 rounded-full overflow-hidden flex-shrink-0">
            {checkin.user.avatarUrl && (
              <img src={checkin.user.avatarUrl} alt="" className="w-full h-full object-cover" />
            )}
          </div>
          <span className="font-medium">{checkin.user.nickname}</span>
          <span className="text-gray-400 ml-auto">{formatCheckinTime(checkin.checkinAt)}</span>
        </li>
      ))}
    </ul>
  );
}
